module.exports = __webpack_public_path__ + "whatsapp-9b6cda514d5f4106ba90.svg";